export enum SignUpRoutes {
  Country = 'country',
}
